export default "__VITE_ASSET__f7027fbc__"